export function signInUrl(redirectTo: string): string {
  return authUrl("/api/auth/login", redirectTo);
}

export function signUpUrl(redirectTo: string): string {
  return authUrl("/api/auth/login", redirectTo);
}

function authUrl(path: "/api/auth/login", redirectTo: string): string {
  const url = new URL(path, window.location.origin);
  url.searchParams.set("redirect", redirectTo);
  return url.toString();
}
